// react
import React, { useState } from "react";

// components
import Radio from "../../../components/Inputs/Radio";
import Pagination from "../../../components/Pagination";

// dependencies
import PropTypes from "../../../lib/prop-types";

// style
import css from "../AddFormModal.module.scss";

const SelectEasyAddForm = (props) => {
	const { handleSetAddForm, addFormData, easyAddForms = [] } = props;

	const [currentPage, setCurrentPage] = useState(1);

	const addAsLookup = {
		manager_or_chain_of_command: "Manager",
		admin_or_group_admin: "Admin",
	};

	const handleChange = (form) => {
		const formData = {
			id: form.formID,
			name: form.form_name,
			easyAddConfigID: form._id,
			whoCanAddForm: form.who_can_add_form,
			subject: form.subject_employee_choose_author,
			allowComments: form.allow_comments,
		};
		handleSetAddForm(formData, "form");
	};

	const isManagerOrAdmin = (addAsValue) => {
		if (addAsValue === "admin_or_group_admin" || addAsValue === "manager_or_chain_of_command") {
			return true;
		}
		return false;
	};

	const getEasyAddFormsToRender = (page) => {
		const start = (page - 1) * 10;
		const end = start + 10;
		return easyAddForms.slice(start, end);
	};

	// changing page should also be rendering new set of easy add forms
	const handlePageChange = (nextPage) => {
		setCurrentPage(nextPage);
	};

	const getFormNameForDisplay = (form) => {
		let displayName = form.form_name;
		if (form.subject_employee_choose_author === "anyEmployee") {
			displayName += " (assign authors)";
		} else if (form.subject_employee_choose_author === "self") {
			displayName += " (self-authored)";
		}
		return displayName;
	};

	return (
		<div>
			<div className={css.modalContent}>
				<div className={css.modalDescription}> Which form would you like to add?</div>

				{easyAddForms.length ? (
					<div className={css.reviewItems}>
						<ul>
							{getEasyAddFormsToRender(currentPage).map((form) => (
								<li key={form._id} className={css.reviewItem}>
									<div className={css.reviewSelect}>
										<Radio
											value={form._id === addFormData.form.easyAddConfigID}
											isRadioStyle={true}
											name={getFormNameForDisplay(form)}
											label={getFormNameForDisplay(form)}
											onChange={() => handleChange(form)}
										/>
										<div className={css.reviewLabel} onClick={() => handleChange(form)}>
											{getFormNameForDisplay(form)}
										</div>
									</div>
									{isManagerOrAdmin(form.addAs) ? (
										<div className={css.addAs}>{`Add as ${addAsLookup[form.addAs]}`}</div>
									) : null}
								</li>
							))}
						</ul>
					</div>
				) : null}

				{easyAddForms.length > 10 ? (
					<Pagination
						pageCount={Math.ceil(easyAddForms.length / 10)}
						currentPage={currentPage}
						onClick={handlePageChange}
					/>
				) : null}
			</div>
		</div>
	);
};

SelectEasyAddForm.propTypes = {
	handleSetAddForm: PropTypes.func.isRequired,
	addFormData: PropTypes.object.isRequired,
	easyAddForms: PropTypes.array,
};
export default SelectEasyAddForm;
